import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-not-found-component',
    templateUrl: './not-found-component.component.html',
    imports: [],
    styleUrls: ['./not-found-component.component.css']
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
